import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {Http, HttpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';

import { AbsUtilitiesModule } from '../abs-utilities/abs-utilities.module';

import { AbsPaginationComponent } from './abs-pagination.component';

@NgModule({
  imports: [CommonModule, FormsModule, HttpModule, AbsUtilitiesModule],
  declarations: [AbsPaginationComponent],
  exports: [AbsPaginationComponent],
})
export class AbsPaginationModule { }
